export enum FinanceWithdrawTabsEnum {
  WITHDRAW,
  WITHDRAW_RECORD,
  HEAVEN_RECORD,
  ACCOUNT
}
